import React, { useState } from "react";
import CustomSlider from "./Slider/CustomSlider.js";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs.js";
import seoConfig from "../../hooks/seoConfig.js";
import useSEO from "../../hooks/useSEO.js";

import history_1 from "../../../images/history/history_1.jpg";
import history_2 from "../../../images/history/history_2.jpg";
import history_3 from "../../../images/history/history_3.jpg";
import history_4 from "../../../images/history/history_4.jpg";
import history_5 from "../../../images/history/history_5.jpg";
import history_6 from "../../../images/history/history_6.jpg";
import history_7 from "../../../images/history/history_7.jpg";
import history_8 from "../../../images/history/history_8.jpg";
import history_9 from "../../../images/history/history_9.jpg";
import history_10 from "../../../images/history/history_10.jpg";
import history_11 from "../../../images/history/history_11.jpg";
import history_12 from "../../../images/history/history_12.jpg";
import history_13 from "../../../images/history/history_13.jpg";
import history_14 from "../../../images/history/history_14.jpg";
import history_15 from "../../../images/history/history_15.jpg";
import history_16 from "../../../images/history/history_16.jpg";
import history_17 from "../../../images/history/history_17.jpg";
import history_18 from "../../../images/history/history_18.jpg";
import history_19 from "../../../images/history/history_19.jpg";
import history_20 from "../../../images/history/history_20.jpg";
import history_21 from "../../../images/history/history_21.jpg";
import history_22 from "../../../images/history/history_22.jpg";
import history_23 from "../../../images/history/history_23.jpg";
import history_24 from "../../../images/history/history_24.jpg";
import history_25 from "../../../images/history/history_25.jpg";
import history_26 from "../../../images/history/history_26.jpg";
import history_27 from "../../../images/history/history_27.jpg";
import history_28 from "../../../images/history/history_28.jpg";
import history_29 from "../../../images/history/history_29.jpg";
import history_30 from "../../../images/history/history_30.jpg";
import history_31 from "../../../images/history/history_31.jpg";

import {
  HISTORY_TEXT_1,
  HISTORY_DESCRIPTION_1,
  HISTORY_TEXT_2,
  HISTORY_DESCRIPTION_2,
  HISTORY_TEXT_3,
  HISTORY_DESCRIPTION_3,
  HISTORY_TEXT_4,
  HISTORY_DESCRIPTION_4,
  HISTORY_TEXT_5,
  HISTORY_DESCRIPTION_5,
  HISTORY_TEXT_6,
  HISTORY_DESCRIPTION_6,
  HISTORY_TEXT_7,
  HISTORY_DESCRIPTION_7,
  HISTORY_TEXT_8,
  HISTORY_DESCRIPTION_8,
  HISTORY_TEXT_9,
  HISTORY_DESCRIPTION_9,
  HISTORY_TEXT_10,
  HISTORY_DESCRIPTION_10,
  HISTORY_TEXT_11,
  HISTORY_DESCRIPTION_11,
  HISTORY_TEXT_12,
  HISTORY_DESCRIPTION_12,
  HISTORY_TEXT_13,
  HISTORY_DESCRIPTION_13,
  HISTORY_TEXT_14,
  HISTORY_DESCRIPTION_14,
  HISTORY_TEXT_15,
  HISTORY_DESCRIPTION_15,
  HISTORY_TEXT_16,
  HISTORY_DESCRIPTION_16,
  HISTORY_TEXT_17,
  HISTORY_DESCRIPTION_17,
  HISTORY_TEXT_18,
  HISTORY_DESCRIPTION_18,
  HISTORY_TEXT_19,
  HISTORY_DESCRIPTION_19,
  HISTORY_TEXT_20,
  HISTORY_DESCRIPTION_20,
  HISTORY_TEXT_21,
  HISTORY_DESCRIPTION_21,
  HISTORY_TEXT_22,
  HISTORY_DESCRIPTION_22,
  HISTORY_TEXT_23,
  HISTORY_DESCRIPTION_23,
  HISTORY_TEXT_24,
  HISTORY_DESCRIPTION_24,
  HISTORY_TEXT_25,
  HISTORY_DESCRIPTION_25,
  HISTORY_TEXT_26,
  HISTORY_DESCRIPTION_26,
  HISTORY_TEXT_27,
  HISTORY_DESCRIPTION_27,
  HISTORY_TEXT_28,
  HISTORY_DESCRIPTION_28,
  HISTORY_TEXT_29,
  HISTORY_DESCRIPTION_29,
  HISTORY_TEXT_30,
  HISTORY_DESCRIPTION_30,
  HISTORY_TEXT_31,
  HISTORY_DESCRIPTION_31,
} from "./HistoryText.js";

const historys = [
  {
    text: HISTORY_TEXT_1,
    description: HISTORY_DESCRIPTION_1,
    image: history_1,
  },
  {
    text: HISTORY_TEXT_2,
    description: HISTORY_DESCRIPTION_2,
    image: history_2,
  },
  {
    text: HISTORY_TEXT_3,
    description: HISTORY_DESCRIPTION_3,
    image: history_3,
  },
  {
    text: HISTORY_TEXT_4,
    description: HISTORY_DESCRIPTION_4,
    image: history_4,
  },
  {
    text: HISTORY_TEXT_5,
    description: HISTORY_DESCRIPTION_5,
    image: history_5,
  },
  {
    text: HISTORY_TEXT_6,
    description: HISTORY_DESCRIPTION_6,
    image: history_6,
  },
  {
    text: HISTORY_TEXT_7,
    description: HISTORY_DESCRIPTION_7,
    image: history_7,
  },
  {
    text: HISTORY_TEXT_8,
    description: HISTORY_DESCRIPTION_8,
    image: history_8,
  },
  {
    text: HISTORY_TEXT_9,
    description: HISTORY_DESCRIPTION_9,
    image: history_9,
  },
  {
    text: HISTORY_TEXT_10,
    description: HISTORY_DESCRIPTION_10,
    image: history_10,
  },
  {
    text: HISTORY_TEXT_11,
    description: HISTORY_DESCRIPTION_11,
    image: history_11,
  },
  {
    text: HISTORY_TEXT_12,
    description: HISTORY_DESCRIPTION_12,
    image: history_12,
  },
  {
    text: HISTORY_TEXT_13,
    description: HISTORY_DESCRIPTION_13,
    image: history_13,
  },
  {
    text: HISTORY_TEXT_14,
    description: HISTORY_DESCRIPTION_14,
    image: history_14,
  },
  {
    text: HISTORY_TEXT_15,
    description: HISTORY_DESCRIPTION_15,
    image: history_15,
  },
  {
    text: HISTORY_TEXT_16,
    description: HISTORY_DESCRIPTION_16,
    image: history_16,
  },
  {
    text: HISTORY_TEXT_17,
    description: HISTORY_DESCRIPTION_17,
    image: history_17,
  },
  {
    text: HISTORY_TEXT_18,
    description: HISTORY_DESCRIPTION_18,
    image: history_18,
  },
  {
    text: HISTORY_TEXT_19,
    description: HISTORY_DESCRIPTION_19,
    image: history_19,
  },
  {
    text: HISTORY_TEXT_20,
    description: HISTORY_DESCRIPTION_20,
    image: history_20,
  },
  {
    text: HISTORY_TEXT_21,
    description: HISTORY_DESCRIPTION_21,
    image: history_21,
  },
  {
    text: HISTORY_TEXT_22,
    description: HISTORY_DESCRIPTION_22,
    image: history_22,
  },
  {
    text: HISTORY_TEXT_23,
    description: HISTORY_DESCRIPTION_23,
    image: history_23,
  },
  {
    text: HISTORY_TEXT_24,
    description: HISTORY_DESCRIPTION_24,
    image: history_24,
  },
  {
    text: HISTORY_TEXT_25,
    description: HISTORY_DESCRIPTION_25,
    image: history_25,
  },
  {
    text: HISTORY_TEXT_26,
    description: HISTORY_DESCRIPTION_26,
    image: history_26,
  },
  {
    text: HISTORY_TEXT_27,
    description: HISTORY_DESCRIPTION_27,
    image: history_27,
  },
  {
    text: HISTORY_TEXT_28,
    description: HISTORY_DESCRIPTION_28,
    image: history_28,
  },
  {
    text: HISTORY_TEXT_29,
    description: HISTORY_DESCRIPTION_29,
    image: history_29,
  },
  {
    text: HISTORY_TEXT_30,
    description: HISTORY_DESCRIPTION_30,
    image: history_30,
  },
  {
    text: HISTORY_TEXT_31,
    description: HISTORY_DESCRIPTION_31,
    image: history_31,
  },
];

export default function History() {
  useSEO(seoConfig.history);

  const [currentIndex, setCurrentIndex] = useState(0);

  const handleNext = () => {
    if (currentIndex < historys.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handlePrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const currentSlide = historys[currentIndex];

  return (
    <section className="history">
      <Breadcrumbs />

      <h1 className="contacts__title history__title">История института</h1>

      <button
        className="prevention__left employees__left history__left"
        onClick={handlePrev}
      ></button>

      <button
        className="prevention__right employees__right history__right"
        onClick={handleNext}
      ></button>

      <CustomSlider
        text={currentSlide.text}
        description={currentSlide.description}
        image={currentSlide.image}
      />
    </section>
  );
}
